import { getSimilarArtworks } from 'api/artworks'
import { ArtworkCard } from 'components/artwork/ArtworkCard'
import { Carousel } from 'components/carousels/Carousel'
import { useCurrencies } from 'contexts'
import React from 'react'
import { useQuery } from 'react-query'
import { FilterArtworkHitProps, PropsWithClassName } from 'types'
import { pickHitPrices } from 'utils/instantsearch'
import { getArtworkNameWithEdition, getLink } from 'utils/strings'
import { getArtworkUrl } from 'utils/urls'

interface LooksSimilarCarouselProps extends PropsWithClassName {
  artworkId: number | null
}

const Hit = (hit: FilterArtworkHitProps & { page?: number }) => {
  const { userCurrency } = useCurrencies()
  const { objectID, artists, name, images, editionName } = hit
  const { lowestAsk, highestBid } = pickHitPrices(hit, userCurrency)

  const id = Number(objectID.split('_')[1])

  let href = getArtworkUrl(artists, name, id, editionName)

  if (editionName === 'Main') {
    if (href.includes('?')) href += '&showRelevantEdition'
    else href += '?showRelevantEdition'
  }

  return (
    <ArtworkCard
      artists={artists}
      artworkName={getArtworkNameWithEdition(name, editionName)}
      artistName={artists?.[0]?.name}
      src={getLink(images?.thumbnail || images?.small || images?.xs)}
      href={href}
      // onLinkClick={() => {
      //   saveScroll({ page, redirectedFrom: 'artworks' })
      // }}
      highestBid={{ price: highestBid }}
      lowestAsk={{ price: lowestAsk }}
      className={hit.className as string}
    />
  )
}

export const LooksSimilarCarousel = ({
  artworkId,
}: LooksSimilarCarouselProps) => {
  const { data: moreArtworks } = useQuery(
    ['similar-artworks', artworkId],
    async () => {
      const result = await getSimilarArtworks(artworkId as number)

      if (!result || !result.data?.length) return []

      return result.data
    },
    {
      keepPreviousData: true,
      refetchOnWindowFocus: true,
    }
  )

  return (
    <>
      {artworkId && moreArtworks && moreArtworks.length > 0 && (
        <Carousel
          title='Similar Works'
          className='bg-cool-50 pb-6 pt-8 sm:px-6 md:px-0 lg:pb-8 lg:pt-12'
        >
          {moreArtworks.map((artwork, index) => (
            <Hit key={index} {...artwork} />
          ))}
        </Carousel>
      )}
    </>
  )
}
